import { Form } from "antd";
import CommonComponents from "../../components/Commons";
import ContentLayoutManagement from "../../layouts/ContentLayoutManagement";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { changeDataBreadcrumb } from "../../store/reducers/layoutSlice";
import { baseRoutes } from "../../router/RouterPage";
import { useNavigate } from "react-router-dom";
import orderService from "../../services/order/order.service";
import orderTaskingService from "../../services/orderTasking/orderTasking.service";
import { createFeedbackAsync } from "../../store/reducers/feedbackSlice";
import { setLoadingGlobal } from "../../store/reducers/appCommonSlice";
import { showError, showSuccess } from "../../helpers/toast";

const AddFeedbackPage = () =>
{
      const [form] = Form.useForm();
      const { t } = useTranslation();
      const dispatch = useDispatch();
      const navigate = useNavigate();

      const type = Form.useWatch(["type"], form);

      const [typeOrder, setTypeOrder] = useState("archive");
      const [dataOrder, setDataOrder] = useState<any>([]);
      const [radioChecked, setRadioChecked] = useState("SYSTEM");
      const [radioCheckedPriority, setRadioCheckedPriority] = useState("LOW");

      const getListOrder = async () =>
      {
            let res: any =
                  typeOrder === "archive"
                        ? await orderService.GetOrderUser({})
                        : await orderTaskingService.GetOrderTasking({
                              type_order: "tasking",
                        });

            setDataOrder(
                  res?.data?.data?.content_page?.map((item?: any) => ({
                        label: item?.name,
                        value: item?.id,
                  }))
            );
      };
      useEffect(() =>
      {
            if (radioChecked === "ORDER")
            {
                  getListOrder();
            }
      }, [radioChecked, typeOrder]);

      useEffect(() =>
      {
            dispatch(
                  changeDataBreadcrumb([
                        {
                              title: t("Feedbacks"),
                              path: baseRoutes.feedback.children.getList.path,
                        },
                        { title: t("Create") },
                  ])
            );
            return () =>
            {
                  dispatch(changeDataBreadcrumb([]));
            };
      }, []);
      return (
            <ContentLayoutManagement
                  header={
                        <div className="!pr-2 !w-full">
                              <div className="flex justify-end gap-2">
                                    <CommonComponents.ButtonUI
                                          commonType="default"
                                          className="btn-cancel w-[96px]"
                                          onClick={() => navigate(-1)}
                                    >
                                          {t("Cancel")}
                                    </CommonComponents.ButtonUI>
                                    <CommonComponents.ButtonUI
                                          htmlType="submit"
                                          className="h-[28px] w-[96px]"
                                          form="form-add-feedback"
                                    >
                                          {t("Save")}
                                    </CommonComponents.ButtonUI>
                              </div>
                        </div>
                  }
            >
                  <Form
                        //   initialValues={initialValues}
                        form={form}
                        className="div-form-small !justify-start !pt-[85px]"
                        name="form-add-feedback"
                        onFinish={async (values) =>
                        {
                              dispatch(setLoadingGlobal(true))
                              let payload = {
                                    title: values?.title,
                                    description: values?.description,
                                    priority: radioCheckedPriority,

                                    type: radioChecked,
                                    orderId: radioChecked === "ORDER" ? values?.orderId : null,
                              };
                              // @ts-ignore
                              let res = await dispatch(createFeedbackAsync(payload)).unwrap();
                              if (res?.status === 201)
                              {
                                    showSuccess(t('Successfully'))
                                    navigate(-1)
                              } else
                              {
                                    showError(t('Error'))
                              }

                              dispatch(setLoadingGlobal(false))
                        }}
                  >
                        <CommonComponents.FormFieldUI
                              name="title"

                              rules={[{ required: true, message: t('Required') }]}
                              component={
                                    <CommonComponents.InputUI
                                          // required
                                          label={t("Title")}
                                          placeholder={t("Title")}
                                    />
                              }
                        />

                        <CommonComponents.FormFieldUI
                              name="description"
                              component={
                                    <CommonComponents.TextAreaUI
                                          optional
                                          label={t("Description")}
                                          placeholder={t("Description")}
                                    />
                              }
                        />

                        <CommonComponents.FormFieldUI
                              name="priority"
                              className="!w-full"
                              component={
                                    <CommonComponents.RadioUI
                                          label={t("Priority")}
                                          valueChecked={radioCheckedPriority}
                                          setValueChecked={(e) => setRadioCheckedPriority(e.target.value)}
                                          radios={[
                                                { title: t("Low"), value: "LOW" },
                                                { title: t("Medium"), value: "MEDIUM" },
                                                { title: t("High"), value: "HIGH" },
                                                { title: t("Urgent"), value: "URGENT" },
                                          ]}
                                    />
                              }
                        />

                        <CommonComponents.FormFieldUI
                              name="type"
                              className="!w-full"
                              component={
                                    <CommonComponents.RadioUI
                                          label={t("Type")}
                                          valueChecked={radioChecked}
                                          setValueChecked={(e) => setRadioChecked(e.target.value)}
                                          radios={[
                                                { title: t("System"), value: "SYSTEM" },
                                                { title: t("Order"), value: "ORDER" },
                                          ]}
                                    />
                              }
                        />

                        {radioChecked === "ORDER" && (
                              <div className="flex gap-4 !w-full">
                                    <CommonComponents.FormFieldUI
                                          className="!w-full"
                                          name="typeOrder"
                                          initialValue={typeOrder}
                                          component={
                                                <CommonComponents.SelectUI
                                                      value={typeOrder}
                                                      options={[
                                                            { label: t("Archive"), value: "archive" },
                                                            { label: t("Tasking"), value: "tasking" },
                                                      ]}
                                                      onChange={(val) =>
                                                      {
                                                            setTypeOrder(val);
                                                      }}
                                                      label={t("Type Order")}
                                                      placeholder={t("Select")}
                                                />
                                          }
                                    />
                                    <CommonComponents.FormFieldUI
                                          name="orderId"
                                          className="!w-full"


                                          rules={[{ required: true, message: t('Required') }]}
                                          component={
                                                <CommonComponents.SelectUI

                                                      options={dataOrder}
                                                      label={t("Order")}
                                                      placeholder={t("Select")}
                                                />
                                          }
                                    />
                              </div>
                        )}
                  </Form>
            </ContentLayoutManagement>
      );
};

export default AddFeedbackPage;
